<script>
import DataTableCpfCnpjColumnVue from 'Support/components/data-table/DataTableColumns/DataTableCpfCnpjColumn.vue';
import DataTableCurrencyColumnVue from 'Support/components/data-table/DataTableColumns/DataTableCurrencyColumn.vue';
import DataTableDateColumnVue from 'Support/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import CrudListVue from 'Support/components/crud/CrudList.vue';
import RepurchaseRequest from 'Domain/financial/RepurchaseRequest';

export default {
  name: 'RepurchaseList',
  extends: CrudListVue,
  data: () => ({
    hideEdit: true,
    hideDelete: true,
    requestClass: RepurchaseRequest,
    headers: [
      {
        text: 'Conta a receber ID',
        value: 'contasAReceberId',
      },
      {
        text: 'Cliente',
        value: 'nomeCliente',
      },
      {
        text: 'CPF/CNPJ',
        value: 'cpfCnpjCliente',
        component: DataTableCpfCnpjColumnVue,
      },
      {
        text: 'Tipo',
        value: 'tipo',
      },
      {
        text: 'Código SGV Cobrança',
        value: 'cobrancaSgvId',
      },
      {
        text: 'Dias vencidos',
        value: 'diasVencida',
      },
      {
        text: 'Juros',
        value: 'valorJurosCalculado',
        component: DataTableCurrencyColumnVue,
      },
      {
        text: 'Valor',
        value: 'valorProrrogacaoTecfin',
        component: DataTableCurrencyColumnVue,
      },
      {
        text: 'Total',
        value: 'valorTotalBoletoSgv',
        component: DataTableCurrencyColumnVue,
      },
      {
        text: 'Valor recompra',
        value: 'valorUnitarioRecompraCalculado',
        component: DataTableCurrencyColumnVue,
      },
      {
        text: 'Data da contratação',
        value: 'dataContratacao',
        component: DataTableDateColumnVue,
      },
    ],
  }),
};
</script>
